module.exports = __webpack_public_path__ + "static/media/undraw_visual_data_b1wx.c1b27570.svg";